import { ReformSetError } from '@kodkafa/reform/dist/Form';
import { ValidationErrorDto } from '@/types/error.type';

export function errorHandler(
  error: {
    property: string;
    message: string;
    data: {
      message: string;
      validations: ValidationErrorDto[];
      error: string;
    };
    status: number;
    error: string;
  },
  setError: ReformSetError,
  property?: string,
): boolean {
  console.log({ error });
  if (Array.isArray(error?.data?.validations) && error?.data?.validations.length) {
    error?.data?.validations.map((i) => {
      setError(i.property, { message: Object.values(i.constraints).toString() });
    });
    return true;
  } else if (property || error?.property) {
    setError(property || error.property, {
      message: error?.data?.error || error?.data?.message || error.message,
    });
    return true;
  } else if (typeof error?.data?.message === 'string' || typeof error?.message === 'string') {
    setError('generic', { message: error?.message || error?.data?.message });
    return true;
  } else if (error?.status) {
    setError('generic', {
      message: error?.error || String(error.status),
    });
    return true;
  } else if (error) {
    setError('generic', {
      message: String(error),
    });
    return true;
  } else return false;
}
